import { useMutation } from 'react-query';
import {
  createDefenseIntegrationAsync,
  deleteDefenseIntegrationAsync,
  getDefenseIntegrationByIdAsync,
  updateDefenseIntegrationAsync,
} from '../../index';

export const useCreateDefenseIntegration = () =>
  useMutation(createDefenseIntegrationAsync);

export const useUpdateDefenseIntegration = () =>
  useMutation(updateDefenseIntegrationAsync);

export const useDeleteDefenseIntegration = () =>
  useMutation(deleteDefenseIntegrationAsync);

export const useGetDefenseIntegrationById = () =>
  useMutation(getDefenseIntegrationByIdAsync);
